import { MockAdsTypeId, MockCustomers } from '../../../common/type';
import { is } from '../../../util/is';
import { CustomerDiscountType, IAdsTypeInfo, ICustomerCustomPricing } from './ads-checkout-type';

export const getMockAdsTypeInfo = (): IAdsTypeInfo[] => [
  { idKey: 'Classic', name: 'Classic Ad', basePrice: 269.99 },
  { idKey: 'Standout', name: 'Standout Ad', basePrice: 322.99 },
  { idKey: 'Premium', name: 'Premium Ad', basePrice: 394.99 }
];

export const getMockCustomerCustomPricing = (customerId: string): ICustomerCustomPricing => {
  const mockData = CUSTOMER_CUSTOM_PRICING_DATA[customerId];

  return is.Nil(mockData)
    ? {
        customerId,
        discounts: []
      }
    : mockData;
};

const [Apple, Ford, Nike, Unilever] = MockCustomers;

const CUSTOMER_CUSTOM_PRICING_DATA: {
  [key: string]: ICustomerCustomPricing;
} = {
  [Unilever.id]: {
    customerId: Unilever.id,
    discounts: [
      {
        discount: {
          freeQty: 1,
          packSize: 3,
          type: CustomerDiscountType.BulkBonusPack
        },
        adsTypeId: MockAdsTypeId.Classic
      }
    ]
  },
  [Apple.id]: {
    customerId: Apple.id,
    discounts: [
      {
        discount: {
          discountedPrice: 299.99,
          type: CustomerDiscountType.PriceOverride
        },
        adsTypeId: MockAdsTypeId.Standout
      }
    ]
  },
  [Nike.id]: {
    customerId: Nike.id,
    discounts: [
      {
        discount: {
          discountedPrice: 379.99,
          minQty: 4,
          type: CustomerDiscountType.BulkPriceOverride
        },
        adsTypeId: MockAdsTypeId.Premium
      }
    ]
  },
  [Ford.id]: {
    customerId: Ford.id,
    discounts: [
      {
        discount: {
          freeQty: 1,
          packSize: 5,
          type: CustomerDiscountType.BulkBonusPack
        },
        adsTypeId: MockAdsTypeId.Classic
      },
      {
        discount: {
          discountedPrice: 309.99,
          type: CustomerDiscountType.PriceOverride
        },
        adsTypeId: MockAdsTypeId.Standout
      },
      {
        discount: {
          discountedPrice: 389.99,
          minQty: 3,
          type: CustomerDiscountType.BulkPriceOverride
        },
        adsTypeId: MockAdsTypeId.Premium
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-mock-data.ts